"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.COUNT_DOWN_DATE_TIMER_LAYOUT = exports.COUNT_DOWN_DATE_TIMER_THEME = exports.COUNT_DOWN_DATE_TIMER_POSITION = void 0;
const react_1 = __importStar(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const next_components_text_info_n_1 = __importStar(require("@gerenciatd/next.components.text-info-n"));
const SVGCircle_1 = __importDefault(require("./SVGCircle"));
const utils_1 = require("./utils");
const enums_1 = require("./enums");
Object.defineProperty(exports, "COUNT_DOWN_DATE_TIMER_POSITION", { enumerable: true, get: function () { return enums_1.COUNT_DOWN_DATE_TIMER_POSITION; } });
Object.defineProperty(exports, "COUNT_DOWN_DATE_TIMER_THEME", { enumerable: true, get: function () { return enums_1.COUNT_DOWN_DATE_TIMER_THEME; } });
Object.defineProperty(exports, "COUNT_DOWN_DATE_TIMER_LAYOUT", { enumerable: true, get: function () { return enums_1.COUNT_DOWN_DATE_TIMER_LAYOUT; } });
const TEXTINFO_NUMBER_PROPS = {
    className: 'number',
    size: next_components_text_info_n_1.TEXT_INFO_SIZE.TITLE6,
    color: next_components_text_info_n_1.TEXT_INFO_COLOR.WHITE,
};
const TEXTINFO_LABEL_PROPS = {
    className: 'label',
    size: next_components_text_info_n_1.TEXT_INFO_SIZE.CAPTION1,
    color: next_components_text_info_n_1.TEXT_INFO_COLOR.WHITE,
};
const isFrontApp = typeof window !== 'undefined';
//
const shouldRender = (duration, visibleItems) => {
    if (duration) {
        const { days, hours, minutes, seconds } = duration;
        const { visibleHours, visibleMinutes, visibleSeconds } = visibleItems;
        if (days > 0 ||
            (visibleHours &&
                (hours > 0 ||
                    (visibleMinutes && (minutes > 0 || (visibleSeconds && seconds > 0)))))) {
            return true;
        }
        return false;
    }
    return false;
};
class CountDownDateTimer extends react_1.Component {
    constructor(props) {
        super(props);
        this.countDown = () => {
            const { startDate, endDate } = this.state;
            const { visibleItems } = this.props;
            const duration = (0, utils_1.setUpDate)(startDate, endDate);
            const render = shouldRender(duration, visibleItems);
            if (render) {
                this.setState(Object.assign({ render }, duration));
            }
            else {
                clearInterval(this.interval);
                this.setState({
                    render,
                });
            }
        };
        const { startDate, endDate } = this.props;
        this.state = {
            render: false,
            startDate,
            endDate,
            days: 0,
            hours: 0,
            minutes: 0,
            seconds: 0,
        };
    }
    componentDidMount() {
        const { startDate, endDate } = this.state;
        const { visibleItems } = this.props;
        const duration = (0, utils_1.setUpDate)(startDate, endDate);
        const render = shouldRender(duration, visibleItems);
        if (render) {
            this.interval = setInterval(this.countDown, 1000);
        }
        else {
            this.setState({
                render,
            });
        }
    }
    static getDerivedStateFromProps(props, state) {
        const { startDate: newStartDate, endDate: newEndDate, visibleItems, } = props;
        const { startDate, endDate } = state;
        if ((isFrontApp && newStartDate !== startDate) || newEndDate !== endDate) {
            // Fechas nuevas
            const duration = (0, utils_1.setUpDate)(newStartDate, newEndDate);
            const render = shouldRender(duration, visibleItems);
            return Object.assign(Object.assign(Object.assign({}, state), { render, startDate: newStartDate, endDate: newEndDate }), duration);
        }
        return Object.assign({}, state);
    }
    componentDidUpdate(prevProps, prevState) {
        const { startDate: newStartDate, endDate: newEndDate, render } = this.state;
        const { startDate, endDate } = prevState;
        if (render && (newStartDate !== startDate || newEndDate !== endDate)) {
            if (this.interval > 0) {
                clearInterval(this.interval);
            }
            this.interval = setInterval(this.countDown, 1000);
        }
    }
    componentWillUnmount() {
        if (this.interval) {
            clearInterval(this.interval);
        }
    }
    render() {
        const { className, colorTheme, claim, position, visibleItems, layout, cySelector, custoObjectInfo, } = this.props;
        const { visibleDays, visibleHours, visibleMinutes, visibleSeconds } = visibleItems;
        const circleColor = (0, utils_1.decideCircleColor)(colorTheme);
        const { days, hours, minutes, seconds, render } = this.state;
        const daysRadius = (0, utils_1.mapNumber)(days, 30, 0, 360, 0);
        const hoursRadius = (0, utils_1.mapNumber)(hours, 24, 0, 360, 0);
        const minutesRadius = (0, utils_1.mapNumber)(minutes, 60, 0, 360, 0);
        const secondsRadius = (0, utils_1.mapNumber)(seconds, 60, 0, 360, 0);
        let fadeOutCss = '';
        if (
        // NO muestra horas
        (!visibleHours &&
            days === 1 &&
            hours === 0 &&
            minutes === 0 &&
            seconds === 0) ||
            // NO muestra minutos
            (!visibleMinutes &&
                days === 0 &&
                hours === 1 &&
                minutes === 0 &&
                seconds === 0) ||
            // NO muestra segundos
            (!visibleSeconds &&
                days === 0 &&
                hours === 0 &&
                minutes === 1 &&
                seconds === 0) ||
            // Muestra segundos
            (days === 0 && hours === 0 && minutes === 0 && seconds === 1)) {
            fadeOutCss = 'countdown--fadeout';
        }
        let editModal = null;
        let classEditName = '';
        if (custoObjectInfo) {
            editModal = () => {
                custoObjectInfo.handler(custoObjectInfo.entryPoint);
            };
            classEditName = 'custo-editable';
        }
        if (render) {
            return (react_1.default.createElement("div", { key: `${days}${hours}${minutes}${seconds}`, className: `classEditName countdown countdown-n countdown--theme-${colorTheme} ${fadeOutCss} countdown--layout-${layout} ${className}`, "cy-data": cySelector, onClick: editModal },
                react_1.default.createElement("div", { className: `container countdown_container countdown--position-${position}` },
                    claim && (react_1.default.createElement(next_components_text_info_n_1.default, { className: "countdown_claim", text: claim, color: circleColor.text, fontType: next_components_text_info_n_1.TEXT_INFO_FONT_WEIGHT.REGULAR, size: next_components_text_info_n_1.TEXT_INFO_SIZE.TITLE6 })),
                    react_1.default.createElement("div", { className: "countdown_counter" },
                        visibleDays && days >= 0 && (react_1.default.createElement("div", { className: "countdown-time-item days" },
                            react_1.default.createElement("div", { className: "countdown-item" },
                                react_1.default.createElement(SVGCircle_1.default, { color: circleColor.bg, radius: 359.999 }),
                                react_1.default.createElement(SVGCircle_1.default, { color: circleColor.counter, radius: daysRadius }),
                                react_1.default.createElement(next_components_text_info_n_1.default, Object.assign({ key: `${days}${daysRadius}` }, TEXTINFO_NUMBER_PROPS, { text: `${days}`, color: circleColor.text }))),
                            react_1.default.createElement(next_components_text_info_n_1.default, Object.assign({}, TEXTINFO_LABEL_PROPS, { text: "d\u00EDas", color: circleColor.text, className: "padding_adjustment" })))),
                        visibleHours && hours >= 0 && (react_1.default.createElement("div", { className: "countdown-time-item hours" },
                            react_1.default.createElement("div", { className: "countdown-item" },
                                react_1.default.createElement(SVGCircle_1.default, { color: circleColor.bg, radius: 359.999 }),
                                react_1.default.createElement(SVGCircle_1.default, { color: circleColor.counter, radius: hoursRadius }),
                                react_1.default.createElement(next_components_text_info_n_1.default, Object.assign({ key: `${hours}${hoursRadius}` }, TEXTINFO_NUMBER_PROPS, { text: `${hours}`, color: circleColor.text }))),
                            react_1.default.createElement(next_components_text_info_n_1.default, Object.assign({}, TEXTINFO_LABEL_PROPS, { text: "h", color: circleColor.text, className: "padding_adjustment" })))),
                        visibleMinutes && minutes >= 0 && (react_1.default.createElement("div", { className: "countdown-time-item minutes" },
                            react_1.default.createElement("div", { className: "countdown-item" },
                                react_1.default.createElement(SVGCircle_1.default, { color: circleColor.bg, radius: 359.999 }),
                                react_1.default.createElement(SVGCircle_1.default, { color: circleColor.counter, radius: minutesRadius }),
                                react_1.default.createElement(next_components_text_info_n_1.default, Object.assign({ key: `${minutes}${minutesRadius}` }, TEXTINFO_NUMBER_PROPS, { text: `${minutes}`, color: circleColor.text }))),
                            react_1.default.createElement(next_components_text_info_n_1.default, Object.assign({}, TEXTINFO_LABEL_PROPS, { text: "min", color: circleColor.text, className: "padding_adjustment" })))),
                        visibleSeconds && seconds >= 0 && (react_1.default.createElement("div", { className: "countdown-time-item seconds" },
                            react_1.default.createElement("div", { className: "countdown-item" },
                                react_1.default.createElement(SVGCircle_1.default, { color: circleColor.bg, radius: 359.999 }),
                                react_1.default.createElement(SVGCircle_1.default, { color: circleColor.counter, radius: secondsRadius }),
                                react_1.default.createElement(next_components_text_info_n_1.default, Object.assign({ key: `${seconds}${secondsRadius}` }, TEXTINFO_NUMBER_PROPS, { text: `${seconds}`, color: circleColor.text }))),
                            react_1.default.createElement(next_components_text_info_n_1.default, Object.assign({}, TEXTINFO_LABEL_PROPS, { text: "s", color: circleColor.text, className: "padding_adjustment" }))))))));
        }
        if (custoObjectInfo) {
            return (react_1.default.createElement("div", { className: classEditName, onClick: editModal }, "CountDownDateTimer"));
        }
        return null;
    }
}
CountDownDateTimer.propTypes = {
    /**
     * {
     *  "info": "Nombre de la clase",
     *  "kind": "both",
     *  "beautifulName": "className"
     * }
     */
    className: prop_types_1.default.string,
    /**
     * {
     *  "info": "Visualizacion del contador",
     *  "kind": "both",
     *  "beautifulName": "layout"
     * }
     */
    layout: prop_types_1.default.string,
    /**
     * {
     *  "info": "Texto del contador",
     *  "kind": "both",
     *  "beautifulName": "claim"
     * }
     */
    claim: prop_types_1.default.string,
    /**
     * {
     *  "info": "Fecha de incio del contador",
     *  "kind": "both",
     *  "beautifulName": "FechaInicio"
     * }
     */
    startDate: prop_types_1.default.string,
    /**
     * {
     *  "info": "Tiempo de duración del contador",
     *  "kind": "both",
     *  "beautifulName": "Duración"
     * }
     */
    endDate: prop_types_1.default.string,
    /**
     * {
     *  "info": "Tema del contador, sirve para definir el color del texto, el color de background, la alineación del texto,... ",
     *  "kind": "both",
     *  "beautifulName": "Tema"
     * }
     */
    colorTheme: prop_types_1.default.oneOf([
        enums_1.COUNT_DOWN_DATE_TIMER_THEME.PURPLE,
        enums_1.COUNT_DOWN_DATE_TIMER_THEME.PURPLE_REVERSE,
        enums_1.COUNT_DOWN_DATE_TIMER_THEME.WHITE,
        enums_1.COUNT_DOWN_DATE_TIMER_THEME.BLUE,
        enums_1.COUNT_DOWN_DATE_TIMER_THEME.BLUE_DARK,
    ]),
    /**
     * {
     *  "info": "Posicion de los contadores",
     *  "kind": "both",
     *  "beautifulName": "position"
     * }
     */
    position: prop_types_1.default.oneOf([
        enums_1.COUNT_DOWN_DATE_TIMER_POSITION.CENTER,
        enums_1.COUNT_DOWN_DATE_TIMER_POSITION.RIGHT,
        enums_1.COUNT_DOWN_DATE_TIMER_POSITION.LEFT,
    ]),
    /**
     * {
     *  "info": "flag para visibilizar los días ,horas minutos o segundos",
     *  "kind": "both",
     *  "beautifulName": "visibleSeconds"
     * }
     */
    visibleItems: prop_types_1.default.object,
};
CountDownDateTimer.defaultProps = {
    className: '',
    layout: enums_1.COUNT_DOWN_DATE_TIMER_LAYOUT.BAND,
    claim: '',
    startDate: '',
    endDate: '',
    colorTheme: enums_1.COUNT_DOWN_DATE_TIMER_THEME.PURPLE,
    position: enums_1.COUNT_DOWN_DATE_TIMER_POSITION.CENTER,
    visibleItems: {
        visibleDays: true,
        visibleHours: true,
        visibleMinutes: true,
        visibleSeconds: true,
    },
};
exports.default = CountDownDateTimer;
//# sourceMappingURL=index.js.map